
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { useEffect } from 'react';

// Improved version of https://usehooks.com/useOnClickOutside/
var useClickOutside = function useClickOutside(ref, handler) {
  useEffect(function () {
    var startedInside = false;
    var startedWhenMounted = false;
    var listener = function listener(event) {
      // Do nothing if `mousedown` or `touchstart` started inside ref element
      if (startedInside || !startedWhenMounted) return;
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };
    var validateEventStart = function validateEventStart(event) {
      startedWhenMounted = Boolean(ref.current);
      startedInside = Boolean(ref.current && ref.current.contains(event === null || event === void 0 ? void 0 : event.target));
    };
    document.addEventListener("mousedown", validateEventStart);
    document.addEventListener("touchstart", validateEventStart);
    document.addEventListener("click", listener);
    return function () {
      document.removeEventListener("mousedown", validateEventStart);
      document.removeEventListener("touchstart", validateEventStart);
      document.removeEventListener("click", listener);
    };
  }, [ref, handler]);
};

export { useClickOutside as default };
//# sourceMappingURL=hooks.js.map
